/* Ovadora reviews: form (store-email or review-backend mode), photo uploads, lightbox. */
(() => {
  const ALLOWED = ['image/jpeg', 'image/png', 'image/webp'];

  const initLightbox = (root) => {
    const dialog = root.querySelector('[data-review-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const img = dialog.querySelector('[data-review-lightbox-img]');
    root.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-review-image]');
      if (btn) {
        img.src = btn.dataset.reviewImage;
        img.alt = (btn.querySelector('img') || {}).alt || '';
        dialog.showModal();
        return;
      }
      if (event.target.closest('[data-review-lightbox-close]') || event.target === dialog) dialog.close();
    });
  };

  const initForm = (root) => {
    const toggle = root.querySelector('[data-review-toggle]');
    const panel = root.querySelector('[data-review-panel]');
    if (!toggle || !panel) return;
    const form = panel.querySelector('form');

    const open = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      const target =
        panel.querySelector('[data-review-server-error]') ||
        (form && form.dataset.reviewMode === 'contact' && panel.querySelector('[data-review-success]')) ||
        panel.querySelector('.ova-review-stars input[value="1"]');
      if (target) target.focus({ preventScroll: true });
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    const close = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    };
    toggle.addEventListener('click', () => (panel.hidden ? open() : close()));
    panel.addEventListener('click', (event) => {
      if (event.target.closest('[data-review-cancel]')) close();
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
    // Store-email mode reloads the page after sending: show the result straight away.
    if (panel.querySelector('[data-review-server-error]') || (form && form.dataset.reviewMode === 'contact' && panel.querySelector('[data-review-success]'))) open();

    if (!form) return;
    const mode = form.dataset.reviewMode;
    const q = (sel) => form.querySelector(sel);
    const body = q('textarea');
    if (!body) return;

    // Character counter
    const count = q('[data-review-count]');
    const updateCount = () => { if (count) count.textContent = body.value.length; };
    body.addEventListener('input', updateCount);
    updateCount();

    // Selected rating shown as text next to the stars
    const starValue = q('[data-review-stars-value]');
    form.addEventListener('change', (event) => {
      if (event.target.matches('.ova-review-stars input') && starValue) starValue.textContent = `${event.target.value} / 5`;
    });

    // Keyboard: Right/Up = more stars, Left/Down = fewer (DOM order is reversed for the CSS fill effect)
    form.querySelectorAll('.ova-review-stars input').forEach((input) => {
      input.addEventListener('keydown', (event) => {
        const step = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        const current = Number((q('.ova-review-stars input:checked') || {}).value) || 0;
        const next = Math.min(5, Math.max(1, current + step));
        const target = q(`.ova-review-stars input[value="${next}"]`);
        target.checked = true;
        target.focus();
        target.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Variant follows the main product form
    const variantInput = q('[data-review-variant]');
    document.addEventListener('change', () => {
      const main = document.querySelector('#MainContent product-form [name="id"]');
      if (main && variantInput) variantInput.value = main.value;
    });

    // ---------- Photos (review-backend mode) ----------
    const fileInput = q('[data-review-files]');
    const previews = q('[data-review-previews]');
    const addLabel = q('[data-review-add]');
    const imageError = q('[data-review-image-error]');
    const maxPhotos = Number(form.dataset.maxPhotos || 0);
    const maxBytes = Number(form.dataset.maxMb || 10) * 1024 * 1024;
    let photos = [];

    const showImageError = (msg) => {
      if (!imageError) return;
      imageError.textContent = msg || '';
      imageError.hidden = !msg;
    };
    const renderPreviews = () => {
      if (!previews) return;
      previews.innerHTML = '';
      photos.forEach((photo, index) => {
        const li = document.createElement('li');
        li.className = 'ova-review-uploads__item';
        const img = document.createElement('img');
        img.src = photo.url;
        img.alt = '';
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'ova-review-uploads__remove';
        remove.setAttribute('aria-label', `Remove ${photo.file.name}`);
        remove.innerHTML = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        remove.addEventListener('click', () => {
          URL.revokeObjectURL(photo.url);
          photos.splice(index, 1);
          renderPreviews();
          showImageError('');
          if (addLabel && !addLabel.hidden) addLabel.focus();
        });
        li.append(img, remove);
        previews.append(li);
      });
      if (addLabel) addLabel.hidden = photos.length >= maxPhotos;
    };
    if (fileInput) {
      if (addLabel) {
        addLabel.tabIndex = 0;
        addLabel.setAttribute('role', 'button');
        addLabel.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); fileInput.click(); }
        });
      }
      fileInput.addEventListener('change', () => {
        const messages = [];
        const countMsg = form.dataset.msgCount.replace('[count]', maxPhotos);
        [...fileInput.files].forEach((file) => {
          if (!ALLOWED.includes(file.type)) {
            messages.push(form.dataset.msgType.replace('[file]', file.name));
          } else if (file.size > maxBytes) {
            messages.push(form.dataset.msgSize.replace('[file]', file.name).replace('[size]', form.dataset.maxMb));
          } else if (photos.some((p) => p.file.name === file.name && p.file.size === file.size)) {
            // same photo picked twice: ignore
          } else if (photos.length >= maxPhotos) {
            if (!messages.includes(countMsg)) messages.push(countMsg);
          } else {
            photos.push({ file, url: URL.createObjectURL(file) });
          }
        });
        fileInput.value = '';
        renderPreviews();
        showImageError(messages.join(' '));
      });
    }

    // ---------- Validation ----------
    const field = (name) => q(`[data-review-field="${name}"]`);
    const setError = (name, invalid, message) => {
      const f = field(name);
      if (!f) return;
      const msg = f.querySelector('[data-review-error]');
      f.classList.toggle('ova-review-form__field--invalid', invalid);
      if (msg) {
        if (message) msg.textContent = message;
        msg.hidden = !invalid;
      }
      f.querySelectorAll('input:not([type="file"]), textarea').forEach((input) => {
        if (invalid) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      });
    };
    const val = (sel) => (q(sel) || {}).value || '';
    const checks = {
      rating: () => !!q('.ova-review-stars input:checked'),
      name: () => val(`#${form.id}-name`).trim().length > 0,
      email: () => { const e = q(`#${form.id}-email`); return e.value.trim().length > 0 && e.checkValidity(); },
      title: () => val(`#${form.id}-title`).trim().length > 0,
      body: () => body.value.trim().length >= 10 && body.value.length <= 3000,
    };
    Object.keys(checks).forEach((name) => {
      const f = field(name);
      if (!f) return;
      ['input', 'change'].forEach((type) => f.addEventListener(type, () => { if (checks[name]()) setError(name, false); }));
    });
    const validate = () => {
      let first = null;
      Object.entries(checks).forEach(([name, check]) => {
        const ok = check();
        setError(name, !ok);
        if (!ok && !first) first = field(name);
      });
      if (first) (first.querySelector('input, textarea') || first).focus();
      return !first;
    };

    // ---------- Submit ----------
    const alertBox = q('[data-review-alert]');
    const retryBtn = q('[data-review-retry]');
    const submitBtn = q('[data-review-submit]');
    const submitLabel = q('[data-review-submit-label]');
    const originalLabel = submitLabel ? submitLabel.textContent : '';
    const showAlert = (message, canRetryWithoutPhotos) => {
      if (!alertBox) return;
      alertBox.querySelector('[data-review-alert-text]').textContent = message;
      if (retryBtn) retryBtn.hidden = !canRetryWithoutPhotos;
      alertBox.hidden = false;
      alertBox.focus();
    };
    const setLoading = (loading) => {
      if (submitBtn) {
        submitBtn.disabled = loading;
        submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
      if (submitLabel) submitLabel.textContent = loading ? form.dataset.msgSubmitting || originalLabel : originalLabel;
      form.querySelectorAll('input:not([type="hidden"]), textarea, [data-review-cancel]').forEach((el) => { el.disabled = loading; });
    };
    const detail = () => ({
      productId: form.dataset.productId,
      productHandle: form.dataset.productHandle,
      variantId: (variantInput || {}).value,
      rating: Number((q('.ova-review-stars input:checked') || {}).value),
      title: val(`#${form.id}-title`),
      body: body.value,
      name: val(`#${form.id}-name`),
      email: val(`#${form.id}-email`),
      photos: photos.map((p) => p.file),
      form,
    });

    const sendToBackend = async (withPhotos) => {
      const data = new FormData(form);
      if (withPhotos) photos.forEach((p) => data.append('images[]', p.file, p.file.name));
      setLoading(true);
      if (alertBox) alertBox.hidden = true;
      let response;
      let json = {};
      try {
        response = await fetch(form.action, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        json = await response.json().catch(() => ({}));
      } catch (error) {
        setLoading(false);
        showAlert(form.dataset.msgNetwork, withPhotos && photos.length > 0);
        return;
      }
      setLoading(false);
      if (response.ok && json.ok === true) {
        const done = q('[data-review-done]');
        const text = q('[data-review-success-text]');
        const note = q('[data-review-success-note]');
        if (json.status === 'published' && text) text.textContent = form.dataset.msgPublished;
        const partial = (json.image_errors && json.image_errors.length) || (!withPhotos && photos.length);
        if (partial && note) { note.textContent = form.dataset.msgPartial; note.hidden = false; }
        q('[data-review-body]').hidden = true;
        done.hidden = false;
        done.querySelector('[data-review-success]').focus();
        photos.forEach((p) => URL.revokeObjectURL(p.url));
        photos = [];
        return;
      }
      const errors = json.errors || {};
      Object.entries(errors).forEach(([name, message]) => {
        if (name === 'images') showImageError(message);
        else setError(name, true, message);
      });
      const photoProblem = response.status === 413 || !!errors.images;
      const fallback = response.ok ? form.dataset.msgNetwork : form.dataset.msgError;
      showAlert(json.message || fallback, photoProblem && withPhotos && photos.length > 0);
    };
    if (retryBtn) retryBtn.addEventListener('click', () => { if (validate()) sendToBackend(false); });

    // Capture phase on window: our validation runs before Shopify's spam check (hCaptcha).
    window.addEventListener('submit', (event) => {
      if (event.target !== form) return;
      if (!validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const hook = new CustomEvent('ova:review:submit', { cancelable: true, bubbles: true, detail: detail() });
      if (!form.dispatchEvent(hook)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (mode === 'endpoint') {
        event.preventDefault();
        event.stopImmediatePropagation();
        sendToBackend(true);
      }
    }, true);
  };

  const initSlider = (root) => {
    const track = root.querySelector('[data-ova-review-slider]');
    if (!track) return;
    const list = track.querySelector('.ova-reviews__list');
    const prev = track.querySelector('[data-ova-slider-prev]');
    const next = track.querySelector('[data-ova-slider-next]');
    const nav = track.querySelector('.ova-reviews__nav');
    if (!list || !prev || !next) return;
    const step = () => {
      const card = list.querySelector('.ova-review');
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : list.clientWidth;
    };
    const update = () => {
      const max = list.scrollWidth - list.clientWidth;
      if (nav) nav.hidden = max <= 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max - 2;
    };
    prev.addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const start = () => document.querySelectorAll('.ova-reviews').forEach((root) => {
    initLightbox(root);
    initForm(root);
    initSlider(root);
  });
  // Theme editor: re-init a reviews section after it is re-rendered
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.ova-reviews').forEach((root) => {
      initLightbox(root);
      initForm(root);
      initSlider(root);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
